<template>
  <div class="design" :class="{ designWrapFullScreen: fullscreen }" ref="designWrap">
    <!-- :class="{ designWrap: true, clearFix: !fullscreen, designWrapFullScreen: fullscreen }" -->
    <div class="designWrap">
      <DesignHead
        @backAddShop="backAddShopFn"
        @backSave="backSaveFn"
        @backBrandSave="backBrandSaveFn"
        @backPublish="backPublishFn"
        @upIsShowDetail="upIsShowDetail"
        @reDesignCancel="reDesignCancel"
        @reDesignSave="$emit('reDesignSave')"
        :fullscreen="fullscreen"
        :isReDesign="configData.isReDesign"
        :key="printImgInfo.id"
      ></DesignHead>
      <div class="designMain clearFix">
        <LeftWrap
          :configData="configData"
          :orderKeyword="orderKeyword"
          @upRotatedNum="upRotatedNum"
          @upIsShowDetail="upIsShowDetail"
          @upSwitch="
            bl => {
              isSwitch = bl
            }
          "
          ref="LeftWrap"
        />
        <MiddleWrap
          :configData="configData"
          ref="middleWrap"
          @upBackgroundColor="upBackgroundColor"
          @upMenuLeftIndex="upMenuLeftIndex"
          :fullscreen="fullscreen"
          @upRotatedNum="upRotatedNum"
          @design="designFn"
          @fullscreen="fullScreen"
          @exitfullscree="exitFullscreen"
        />
        <div class="imgDetail" :class="{ leftCss: isSwitch }" v-if="showImgDetail">
          <img
            :class="{ fuzzy: showImgDetailData.dtc_enable === 2 }"
            :src="showImgDetailData.user_id >= 0 ? showImgDetailData.show_image_src : showImgDetailData.view_image_src"
          />
          <div class="titleWrap">
            <p class="productName">
              {{
                showImgDetailData.material_name_alias
                  ? showImgDetailData.material_name_alias[1]
                  : showImgDetailData.en_name
              }}
            </p>

            <template v-if="showImgDetailData.user_id >= 0">
              <p class="productCode">
                <span>{{ $t('generic.pixel') }}:{{ showImgDetailData.width }}*{{ showImgDetailData.height }}</span>
              </p>
              <!-- <all-brand-list :detail="showImgDetailData" :language="1"></all-brand-list> -->
            </template>
            <template v-else>
              <p class="productCode">
                <span>{{ $t('generic.productCode') }}:{{ showImgDetailData.code }}</span>
                <span class="price">${{ showImgDetailData.purchase_price }}</span>
              </p>
              <a-tag v-for="(value, index) in showImgDetailData.colors" :key="index" :color="value.tone"></a-tag>
            </template>
          </div>
        </div>
        <RightWrap
          ref="RightWrap"
          @change="change"
          @design="designFn"
          :configData="configData"
          @fullscreen="fullScreen"
          @exitfullscree="exitFullscreen"
          :fullscreen="fullscreen"
        />
      </div>
      <div class="detail" v-if="!configData.showDetail">
        <div class="detailTitle">{{ $t('generic.productDetail') }}</div>
        <div>
          <span class="titleContain">{{ $t('generic.chName') }}:</span>
          <span class="textContain">&nbsp;{{ printImgInfo.name }}</span>
          <span class="titleContain">{{ $t('generic.enName') }}:</span>
          <span class="textContain">&nbsp;{{ printImgInfo.en_name }}</span>
          <span class="titleContain">{{ $t('generic.productCode') }}:</span>
          <span class="textContain">&nbsp;{{ printImgInfo.code }}</span>
        </div>
        <div style="margin-top: 24px">
          <span class="titleContain">{{ $t('generic.productionTechnolegy') }}:</span>
          <span class="textContain">&nbsp;{{ printImgInfo.product_technology_text }}</span>
          <span class="titleContain">{{ $t('generic.productMaterial') }}:</span>
          <span class="textContain">&nbsp;{{ printImgInfo.product_material_text }}</span>
          <span class="titleContain">{{ $t('generic.material') }}:</span>
          <span class="textContain">&nbsp;{{ printImgInfo.product_material_text }}</span>
        </div>
        <div style="margin-top: 24px">
          <!-- <span class="titleContain">其他描述:</span> -->
          <span v-html="printImgInfo.desc"></span>
        </div>
        <div style="margin-top: 24px">
          <a-card :title="$t('generic.productSize')" :bordered="false">
            <template v-if="printImgInfo.attr_values && printImgInfo.attr_values.length">
              <div class="size-wrap">
                <div class="size-head">
                  <div class="head-item">{{ $t('generic.size') }}</div>
                  <template v-if="printImgInfo.attr_values[0].attr_value">
                    <div class="head-item" v-for="(item, i) in printImgInfo.attr_values[0].attr_value" :key="i">
                      {{ item.attr_name }}
                    </div>
                  </template>
                </div>
                <div class="size-body" v-for="(item, i) in printImgInfo.attr_values" :key="i">
                  <div class="body-item">{{ item.size_name }}</div>
                  <template v-if="item.attr_value">
                    <div class="body-item" v-for="(it, x) in item.attr_value" :key="x">{{ it.attr_value }}</div>
                  </template>
                </div>
              </div>
            </template>
          </a-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DesignHead from './components/designHead.vue'
import LeftWrap from './components/leftWrap'
import MiddleWrap from './components/middleWrap'
import RightWrap from './components/rightWrap'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { getUserHotKeys } from '@/api/design'
import hotkeys from 'hotkeys-js'
// import AllBrandList from '@/views/components/allBrandList/index.vue'

export default {
  name: 'Design',
  data() {
    return {
      fullscreen: false,
      isSwitch: false,
      timer: null,
      hotkeys: hotkeys
    }
  },
  components: {
    DesignHead,
    LeftWrap,
    MiddleWrap,
    RightWrap
    // AllBrandList
  },
  props: {
    orderKeyword: {
      type: Number
    },
    configData: {
      type: Object,
      default: () => ({
        showAddShop: true,
        showDetail: true,
        showSave: true,
        saveButText: 'Save product',
        showProduct: true,
        isReDesign: false,
        showReturn: true
      })
    }
  },
  beforeDestroy() {
    this.hotkeys.unbind()
  },
  methods: {
    ...mapMutations({
      setRandom: 'SET_RANDOM',
      setActiveTab: 'SET_ACTIVE_TAB',
      resetFabricList: 'RESET_FABRIC_LIST',
      setHotKeys: 'SET_HOTKEYS',
      setCanvasType: 'SET_CANVAS_TYPE'
    }),
    reDesignCancel() {
      this.$emit('reDesignCancel')
    },
    upIsShowDetail() {
      // 展示左侧商品详情
      const { LeftWrap } = this.$refs
      console.log('printImgInfo====', this.printImgInfo)
      LeftWrap.menuLeftIndex = 0
      LeftWrap.isShowDetail = true
    },
    upRotatedNum(num) {
      // 画面内对象旋转时更新右侧旋转值
      console.log('num===', num)
      const { RightWrap } = this.$refs
      RightWrap.setSliderValue(num)
    },
    upBackgroundColor() {
      const { LeftWrap } = this.$refs
      if (LeftWrap) {
        LeftWrap.getBackgroundColor()
      }
      const activeObject = this.activeFabric.getActiveObject()
      console.log('activeObject===', activeObject)
      const { RightWrap } = this.$refs
      if (activeObject) {
        RightWrap.setSliderValue(Math.round(activeObject.angle))
      } else {
        RightWrap.setSliderValue(0)
      }
    },
    upMenuLeftIndex(n) {
      const { LeftWrap } = this.$refs
      if (LeftWrap) {
        LeftWrap.menuLeftIndex = n
      }
    },
    designFn(id) {
      console.log('id=====1111', id)
      const { LeftWrap } = this.$refs
      if (LeftWrap) {
        LeftWrap.getPrintInfo(id, 1)
      }
    },
    keydownEvent(e) {
      this.fullscreen = !this.fullscreen
      this.$nextTick(() => {
        // this.$refs.middleWrap.$refs.canvasComponent[this.activeDesign - 1].canvasWrapResize()
        const canvases = this.$refs.middleWrap.$refs.canvasComponent
        console.log(111)
        canvases.map(item => {
          item.canvasWrapResize()
        })
      })
    },

    change(id) {
      this.$emit('change', id)
    },
    fullScreen() {
      var element = this.$refs.designWrap
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    bindShortcut() {
      this.hotKeys.map(item => {
        hotkeys(item.enName.toLowerCase(), () => {
          if (item.index < 1) {
            switch (item.index) {
              case -1:
                this.getObjectAndTransform('top', 1)
                break
              case -2:
                this.getObjectAndTransform('top', 0)
                break
              case -3:
                this.getObjectAndTransform('left', 1)
                break
              case -4:
                this.getObjectAndTransform('left', 0)
                break
              case -5:
                this.setCanvasType('')
                this.activeFabric.redo(this.setRandom)
                break
              case -6:
                this.setCanvasType('')
                this.activeFabric.undo(this.setRandom)
                break
              default:
                break
            }
          } else if (item.index > 9 && item.index <= 18) {
            this.otherShortCut(item)
          } else if (item.index === 100) {
            this.setCanvasType('')
            this.$refs.RightWrap.$refs.slide.showBig()
          } else if (item.index === 101) {
            this.setCanvasType('')
            this.$refs.RightWrap.addShop()
          } else if (item.index === 102) {
            this.setCanvasType('')
            this.$refs.LeftWrap.showColorPickModal()
          } else {
            console.log(665564)
            // this.$refs.middleWrap.moveActive(item.index)
            this.$refs.RightWrap.moveActive(item.index)
          }
          return false
        })
      })
    },
    debounce(fn, time) {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setTimeout(() => {
        fn()
      }, time)
    },
    backAddShopFn() {
      this.$refs.RightWrap.addShop()
    },
    backSaveFn() {
      this.$refs.RightWrap.saveConfirm()
    },
    backBrandSaveFn() {
      this.$refs.RightWrap.brandSaveConfirm()
    },
    backPublishFn() {
      this.$refs.RightWrap.publishConfirm()
    },
    otherShortCut(item) {
      switch (item.index) {
        case 10:
          this.$refs.RightWrap.saveConfirm()
          break
        case 11:
          // this.setActiveTab(1)
          this.$refs.LeftWrap.menuLeftIndex = 0
          break
        case 12:
          // this.setActiveTab(2)
          this.$refs.LeftWrap.menuLeftIndex = 1
          break
        case 13:
          this.resetFabricList()
          this.setRandom()
          break
        case 14:
          // this.$refs.middleWrap.createGroupImgEntry(1)
          this.$refs.RightWrap.createGroupImgEntry(1)
          break
        case 15:
          // this.$refs.middleWrap.createGroupImgEntry(4)
          this.$refs.RightWrap.createGroupImgEntry(4)
          break
        case 16:
          // this.rotate(5)
          this.$refs.RightWrap.rotateFn(5)
          break
        case 17:
          // this.rotate(45)
          this.$refs.RightWrap.rotateFn(45)

          break
        case 18:
          // this.rotate(45)
          this.$refs.RightWrap.rotateFn(-5)

          break
        default:
          break
      }
    },
    getObjectAndTransform(type, add) {
      const t = this.activeFabric.getActiveObject()
      if (t) {
        t.set(type, add === 1 ? --t[type] : ++t[type])
        if (t.time === this.activeGroupInfo.code) {
          const objects = this.activeFabric.getObjects()
          const group = objects.find(item => item.type === 'group')
          group.set('left', t.left).setCoords()
          group.set('top', t.top).setCoords()
        }
        this.activeFabric.renderAll()
        this.debounce(this.setRandom, 300)
      } else {
        this.$message.error('Please select a picture')
      }
    },
    rotate(angle) {
      const { activeFabric } = this
      const t = activeFabric.getActiveObject()
      t.rotate(t.angle + angle).setCoords()
      this.activeFabric.renderAll()
      this.setRandom()
    }
  },
  computed: {
    ...mapGetters(['activeFabric', 'activeGroupInfo', 'getToken']),

    ...mapState({
      printImgInfo: state => state.design.printImgInfo,
      showImgDetail: state => state.design.showImgDetail,
      showImgDetailData: state => state.design.showImgDetailData,
      activeDesign: state => state.design.activeDesign,
      hotKeys: state => state.design.hotKeys,
      productDetail: state => state.design.productDetail
    })
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.keydownEvent, false)
    getUserHotKeys().then(res => {
      this.setHotKeys(res.data.hotKeys || [])
      this.bindShortcut()
    })
    if (!this.configData.showProduct) {
      this.upIsShowDetail()
    }
  }
}
</script>

<style lang="less" scoped>
.fuzzy {
  filter: blur(10px);
}
.designWrap {
  width: 100%;
  border-top: none;
  margin: 0 auto;
  position: relative;
  background: #fff;
  min-width: 1400px;
  .imgDetail {
    min-height: 328px;
    width: 250px;
    position: absolute;
    left: 380px;
    background: white;
    z-index: 999;
    top: 55px;
    border: 1px solid #cccccc;
    border-radius: 5px;
    padding: 13px;
    &.leftCss {
      left: 700px;
    }
    img {
      width: 100%;
    }
    .titleWrap {
      padding: 10px;
      word-break: break-all;
      .productName {
        color: #333333;
        font-size: 14px;
        margin-bottom: 0px;
        font-weight: bold;
      }
      .productCode {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333333;
        font-size: 12px;
        margin: 6px 0;
        .price {
          font-size: 20px;
          font-weight: bold;
          color: #de0000;
        }
      }
      .ant-tag {
        height: 15px;
        border: 1px solid #cccccc;
      }
    }
  }
}
.designMain {
  flex: 1;
  display: flex;
  flex-direction: row;
  height: calc(100vh - 55px);
  min-height: 550px;
  background: #f6f7f9;
}
.detail {
  width: 1400px;
  min-width: 1400px;
  margin: 0 auto;
  padding: 18px;
  border-top: none;
  padding-bottom: 100px;
  .detailTitle {
    font-size: 20px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 24px;
  }
  .titleContain {
    font-size: 14px;
    color: #333333;
  }
  .textContain {
    display: inline-block;
    width: 346px;
    white-space: pre-wrap;
    vertical-align: top;
    color: #333333;
  }
  .size-head {
    display: table;
    width: 100%;
  }
  .head-item {
    display: table-cell;
    // display: block;
    width: 120px;
    height: 26px;
    font-size: 16px;
    color: #666;
    line-height: 26px;
    text-align: center;
    vertical-align: middle;
    background: #deedf9;
  }
  .size-body {
    display: table;
    width: 100%;
    margin: 4px 0 0 0;
  }
  .body-item {
    display: table-cell;
    // display: block;
    width: 120px;
    height: 26px;
    margin: 4px 0 0 0;
    font-size: 16px;
    color: #666;
    line-height: 26px;
    text-align: center;
    vertical-align: middle;
    background: #f3f5f7;
  }
}
</style>
